import { getAll, getCurrentSprint } from '@/api/sprint/';
import * as types from '@/store/modules/parametrage/sprint-mutation-type';
import { RESET_STATE } from '@/store/mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    lastUpdate: null,
    lastUpdateHome: null,
    forceLoad: true,
    currentSprint: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [types.SET_LAST_UPDATE](state, lastUpdate) {
    state.lastUpdate = lastUpdate;
  },
  [types.SET_LAST_UPDATE_HOME](state, lastUpdate) {
    state.lastUpdateHome = lastUpdate;
  },
  [types.SET_FORCE_LOAD](state, forceLoad) {
    state.forceLoad = forceLoad;
  },
  [types.SET_CURRENT_SPRINT](state, currentSprint) {
    state.currentSprint = currentSprint;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async load({ commit, state }, payload) {
    const dateLimit = new Date();
    dateLimit.setHours(dateLimit.getHours() - 24);
    if (!state.forceLoad
      && !!state.lastUpdate
      && state.lastUpdate > dateLimit) {
      return {};
    }
    const { items } = (await getAll(payload)).data.result;
    items.forEach(sprint => {
      sprint.open = false;
    });
    commit(types.SET_ITEMS, items);
    commit(types.SET_TOTAL, items.length);
    commit(types.SET_LAST_UPDATE, new Date());
    commit(types.SET_FORCE_LOAD, false);
    return {};
  },
  async loadCurrentSprint({ commit, state }) {
    const dateLimit = new Date();
    dateLimit.setHours(dateLimit.getHours() - 24);
    if (!!state.lastUpdateHome && state.lastUpdateHome > dateLimit) {
      return;
    }
    const { result } = (await getCurrentSprint()).data;
    commit(types.SET_LAST_UPDATE_HOME, new Date());
    commit(types.SET_CURRENT_SPRINT, result);
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  forceLoad: state => {
    return state.forceLoad;
  },
  currentSprint: state => {
    return state.currentSprint;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
